var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgExpenseDisabled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BBBAB9",
    d: "M10.225 7.268c-.627-.347-1.295-.611-1.956-.885-.383-.16-.75-.344-1.074-.602-.638-.509-.515-1.335.231-1.662.212-.093.433-.122.658-.136.866-.046 1.689.113 2.472.49.39.188.519.128.65-.278.14-.43.255-.866.384-1.299.086-.29-.02-.482-.294-.604-.502-.222-1.018-.38-1.56-.466-.707-.11-.707-.113-.71-.823C9.023 0 9.023 0 8.018 0c-.145 0-.29-.003-.436 0-.47.014-.549.096-.562.569-.007.211 0 .423-.003.638-.004.627-.007.618-.608.836-1.454.528-2.353 1.52-2.449 3.106-.086 1.404.648 2.353 1.801 3.043.71.427 1.497.678 2.25 1.012.294.128.575.277.82.482.724.598.591 1.593-.268 1.97-.46.201-.945.25-1.444.188-.77-.096-1.507-.298-2.2-.658-.407-.211-.526-.155-.665.285-.119.38-.225.763-.33 1.146-.142.516-.09.638.403.88.628.303 1.298.459 1.983.568.535.085.551.109.558.664.003.25.003.505.007.756.003.318.155.503.482.51.37.006.744.006 1.114-.004.304-.007.459-.172.459-.48 0-.343.017-.69.003-1.033-.016-.35.136-.53.473-.622.776-.211 1.437-.627 1.946-1.249 1.415-1.718.876-4.233-1.127-5.34z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0V0z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExpenseDisabled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/expense_disabled.117efd60.svg";
export { ForwardRef as ReactComponent };